module.exports = __webpack_public_path__ + "static/media/SF-1-A.1768b4bc.mp3";